// extracted by mini-css-extract-plugin
export default {"player_container":"ImagePlayer_player_container__7EiFB","img":"ImagePlayer_img__YQ5CM","player":"ImagePlayer_player__z6Tt0","play":"ImagePlayer_play__xJCkW"};